<template>
  <footer id="cs-footer-269">
    <div class="cs-container">
      <!-- Logo Group -->
      <div class="cs-logo-group">
        <router-link aria-label="Ajonee home" class="cs-logo" to="/">
          <img
            class="cs-logo-img light"
            loading="lazy"
            decoding="async"
            src="../assets/images/logo-full.png"
            alt="Ajonee logo"
            width="140"
            height="140"
          />
        </router-link>
        <p class="cs-text">Compassionate Care, Empowered Lives</p>
      </div>
      <!-- Links -->
      <ul class="cs-nav">
        <li class="cs-nav-li">
          <span class="cs-header">Sitemap</span>
        </li>
        <li v-for="item in navItems" :key="item.name" class="cs-nav-li">
          <router-link class="cs-nav-link" :to="item.link">{{ item.name }}</router-link>
        </li>
      </ul>
      <!-- Contact Info -->
      <ul class="cs-contact">
        <li class="cs-nav-li">
          <span class="cs-header">Contact</span>
        </li>
        <li class="cs-contact-li">
          <a class="cs-contact-link" href="tel:+61-424232426">+61-424232426</a>
        </li>
        <li class="cs-contact-li">
          <a class="cs-contact-link" href="mailto:info@ajonee.com.au"
            >info@ajonee.com.au</a
          >
        </li>
      </ul>
      <!-- Legal -->
      <ul class="cs-nav">
        <li class="cs-nav-li">
          <span class="cs-header">Legal</span>
        </li>
        <li class="cs-nav-li">
          <router-link class="cs-nav-link" to="/privacy-policy">Privacy Policy</router-link>
        </li>
        <li class="cs-nav-li">
          <router-link class="cs-nav-link" to="/terms-of-use">Terms of Use</router-link>
        </li>
        <li class="cs-nav-li">
          <router-link class="cs-nav-link" to="/cookie-policy">Cookie Policy</router-link>
        </li>
      </ul>
    </div>
    <div class="cs-copyright-bar">
      <p class="cs-copyright-text">
        &copy; {{ currentYear }} Ajonee. All rights reserved.
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      currentYear: new Date().getFullYear(),
      navItems: [
        { name: "Home", link: "/" },
        { name: "About", link: "/about" },
        { name: "Values", link: "/values" },
        { name: "Services", link: "/services" },
        { name: "Careers", link: "/careers" },
        { name: "Contact", link: "/contact" },
        { name: "Feedback", link: "/feedback" },
      ],
      socialLinks: [
        {
          src: "https://csimg.nyc3.digitaloceanspaces.com/Social/google.svg",
          alt: "google",
          ariaLabel: "visit google profile",
          link: "#",
        },
        {
          src: "https://csimg.nyc3.digitaloceanspaces.com/Social/Facebook.svg",
          alt: "facebook",
          ariaLabel: "visit facebook profile",
          link: "#",
        },
        {
          src: "https://csimg.nyc3.digitaloceanspaces.com/Social/instagram.svg",
          alt: "instagram",
          ariaLabel: "visit instagram profile",
          link: "#",
        },
      ],
    };
  },
};
</script>

<style scoped>
/*-- -------------------------- -->
<---          Footer            -->
<--- -------------------------- -*/

/* Mobile - 360px */
@media only screen and (min-width: 0rem) {
  #cs-footer-269 {
    /* 60px - 100px top and bottom */
    padding: clamp(3.75rem, 7.82vw, 6.25rem) 1rem;
    background-color: #ffffff;
    /* Navigation Links */
    /* Contact Links */
  }
  #cs-footer-269 .cs-container {
    width: 100%;
    /* reset on tablet */
    max-width: 34.375rem;
    margin: auto;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    /* 68px - 100px */
    column-gap: clamp(4.25rem, calc(10%), 6.25rem);
  }
  #cs-footer-269 .cs-logo-group {
    /* takes up all the space, lets the other ul's wrap below it */
    width: 100%;
    position: relative;
  }
  #cs-footer-269 .cs-logo {
    /* 210px - 240px */
    width: clamp(13.125rem, 8vw, 15rem);
    height: auto;
    display: block;
    /* 28px - 44px */
    margin-bottom: clamp(1.75rem, 4.17vw, 2.75rem);
  }
  #cs-footer-269 .cs-logo-img {
    width: 100%;
    height: auto;
  }
  #cs-footer-269 .cs-text {
    /* 14px - 16px */
    font-size: clamp(0.875rem, 2.5vw, 1rem);
    line-height: 1.5em;
    margin: 0;
    margin-bottom: 2rem;
    /* changes to 305px at desktop */
    max-width: 33.75rem;
    color: var(--bodyTextColor);
  }
  #cs-footer-269 .cs-nav {
    padding: 0;
    margin: 0;
  }
  #cs-footer-269 .cs-nav-li {
    list-style: none;
    line-height: 1.5em;
    margin-bottom: 0.5rem;
  }
  #cs-footer-269 .cs-nav-li:last-of-type {
    margin-bottom: 0;
  }
  #cs-footer-269 .cs-header {
    font-size: 1rem;
    line-height: 1.5em;
    font-weight: 700;
    margin-bottom: 0.875rem;
    color: var(--bodyTextColor);
    position: relative;
    display: block;
  }
  #cs-footer-269 .cs-nav-link {
    font-size: 1rem;
    text-decoration: none;
    line-height: 1.5em;
    color: var(--bodyTextColor);
    position: relative;
  }
  #cs-footer-269 .cs-nav-link:before {
    /* underline */
    content: "";
    width: 0%;
    height: 0.125rem;
    /* current color of the parent */
    background: currentColor;
    opacity: 1;
    position: absolute;
    display: block;
    bottom: -0.125rem;
    left: 0;
    transition: width 0.3s;
  }
  #cs-footer-269 .cs-nav-link:hover:before {
    width: 100%;
  }
  #cs-footer-269 .cs-contact {
    margin: 0;
    padding: 0;
    width: auto;
    display: flex;
    flex-direction: column;
    align-self: stretch;
  }
  #cs-footer-269 .cs-contact-li {
    list-style: none;
    margin-bottom: 0rem;
  }
  #cs-footer-269 .cs-contact-li:last-of-type {
    margin-bottom: 0;
  }
  #cs-footer-269 .cs-contact-link {
    font-size: 1rem;
    text-decoration: none;
    line-height: 1.5em;
    text-align: left;
    color: var(--bodyTextColor);
    display: inline-block;
  }
  #cs-footer-269 .cs-contact-link:hover {
    text-decoration: underline;
  }
  #cs-footer-269 .cs-address {
    font-size: 1rem;
    margin-bottom: 1.25rem;
  }
  #cs-footer-269 .cs-social-group {
    /* pushes away from the other flex items */
    margin-top: auto;
    margin-left: auto;
  }
  #cs-footer-269 .cs-social {
    display: inline-flex;
    justify-content: flex-start;
    gap: 0.75rem;
  }
  #cs-footer-269 .cs-social-link {
    width: 1.5rem;
    height: 1.5rem;
    background-color: var(--primaryLight);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 1;
    transition: transform 0.3s, background-color 0.3s;
  }
  #cs-footer-269 .cs-social-link:hover {
    background-color: var(--primary);
    transform: translateY(-0.1875rem);
  }
  #cs-footer-269 .cs-social-img {
    height: 0.8125rem;
    width: auto;
    display: block;
  }
}
/* Tablet - 768px */
@media only screen and (min-width: 48rem) {
  #cs-footer-269 .cs-container {
    max-width: 80rem;
    row-gap: 0;
  }
  #cs-footer-269 .cs-logo-group {
    width: auto;
    /* pushes everything to the right of it as far as possible in a flexbox */
    margin-right: auto;
  }
  #cs-footer-269 .cs-text {
    width: 80%;
    max-width: 19.0625rem;
    margin: 0;
  }
  #cs-footer-269 .cs-nav,
  #cs-footer-269 .cs-contact {
    /* 8px - 12px */
    margin-top: clamp(0.5rem, 1.2vw, 0.75rem);
  }
}
#cs-footer-269 .cs-copyright-bar {
  width: 100%;
  border-top: 1px solid #e8e8e8;
  margin-top: clamp(2rem, 5vw, 3rem);
  padding-top: 1.25rem;
}
#cs-footer-269 .cs-copyright-text {
  max-width: 80rem;
  margin: 0 auto;
  text-align: center;
  font-size: 0.85rem;
  color: var(--bodyTextColor);
}
</style>
